import { BuiltinHomeSettingsId } from "../settings/builtinHomeSettingsId";
import { InteriorPaletteName } from "../settings/interiorMaterialSettingsLibrary";

export const DEFAULT_INTERIOR_PALETTE_ID = InteriorPaletteName.INTERIOR_B01;
export const DEFAULT_EXTERIOR_PALETTE_ID = BuiltinHomeSettingsId.Default_01;

export function isDefaultPaletteId(id: string): boolean {
  return id === DEFAULT_INTERIOR_PALETTE_ID || id === DEFAULT_EXTERIOR_PALETTE_ID;
}

export const defaultPaletteIds = new Set([DEFAULT_INTERIOR_PALETTE_ID, DEFAULT_EXTERIOR_PALETTE_ID]);
